<template>
    <div>
        <el-row>
            <el-col>
                <el-card shadow="never">
                    <el-row >
                        <el-col :span="12"><h1 style="text-align:left;margin-top:unset;">Mobile Log Order</h1></el-col>
                        <el-col :span="12" class="text-md-right">
                            <el-button type="primary" circle @click="onShowCustomerEditOrderMobile"><i class="fas fa-eye"></i></el-button>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12" class="text-md-left">
                            <el-radio-group v-model="type" @change="selectedType">
                                <el-radio-button :label="0">All Order</el-radio-button>
                                <el-radio-button :label="1">Shop</el-radio-button>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="12" class="text-md-right" v-if="type === 0">
                            <el-button plain >{{countSelect}} ออเดอร์ที่เลือก</el-button>
                            <el-button type="primary" @click="createShipment" :disabled="countSelect === 0">Create Shipment</el-button>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" style="padding-top:5px;">
                        <el-col :span="8" class="text-md-left" v-if="type === 0">
                            <el-radio-group v-model="editArray" @change="onSelectStatus" >
                                <el-radio-button v-for="status in statusSave" :label="status.id" :key="status.id">{{status.name}} ({{status.count}})</el-radio-button>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="8" v-if="type === 0">
                            <el-radio-group v-model="printStatusSelect" @change="onSelectStatus" :disabled="diableOrderStatusFalse">
                                <el-radio-button v-for="dataPrint in statusPrint" :key="dataPrint.id" :label="dataPrint.value">{{dataPrint.name}} ({{dataPrint.count}})</el-radio-button>
                            </el-radio-group>
                        </el-col>
                        <el-col :span="8" class="text-md-right" v-if="type === 0">
                            <el-checkbox-group v-model="statusSelect" @change="onSelectStatus" :min="1" class="disableCheckStatus">
                                <el-checkbox-button v-for="status in statusList" :label="status.id" :key="status.id" >{{status.name}} ({{status.count}})</el-checkbox-button>
                            </el-checkbox-group>
                        </el-col>
                    </el-row>
                    <el-divider/>
                    <el-row :gutter="20">
                        <keep-alive>
                            <el-col :span="16" class="text-md-left" v-if="type === 0">
                                <el-input placeholder="ค้นหา" v-model="searchOrderId" @keypress.enter.native="onSearch" @input="onSearch(flagFetch = true)"></el-input>
                            </el-col>
                        </keep-alive>
                        <keep-alive>
                            <el-col :span="16" class="text-md-left" v-if="type === 1">
                                <el-input placeholder="ค้นหา" v-model="searchShopName" @keypress.enter.native="onSearch" @input="onSearch(flagFetch = true)"></el-input>
                            </el-col>
                        </keep-alive>
                        <el-col :span="6" class="text-md-left">
                            <el-date-picker
                                v-show="type === 1"
                                v-model="datePickTo"
                                type="date"
                                format="dd-MM-yyyy"
                                value-format="yyyy-MM-dd"
                                style="width: 100%;">
                            </el-date-picker>
                            <el-date-picker
                                v-show="type === 0"
                                v-model="datePickToRange"
                                type="daterange"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd"
                                range-separator="To"
                                style="width: 100%;"
                                start-placeholder="วันที่เริ่มต้น"
                                end-placeholder="วันที่สินสุด">
                            </el-date-picker>
                        </el-col>
                        <el-col :span="2" class="text-md-right">
                           <el-button type="primary" @click="onSearch(flagFetch = true)" prefix-icon="el-icon-search" style="width: 100%;">ค้นหา</el-button>
                        </el-col>
                    </el-row>
                    <el-divider/>
                    <el-row :span="24" style="margin-top:15px;">
                        <el-col class="text-md-left">
                            <component :is="currentTabComponent" ref="selectComponent" @onSearch="onSearchEmit" @countSelect="setCountSelect" @countStatus="setStatusCount"></component>
                        </el-col>
                    </el-row>
                </el-card>
            </el-col>
        </el-row>
        <MobileOrderDialogEditOrder :dialogShowEditOrderMobile.sync="dialogShowEditOrderMobile"/>
    </div>
</template>
<script>
// import fgApi from '@/services/fillgoods'
import MobileAllOrder from '@/components/LogOrder/MobileAllOrder.vue'
import MobileShop from '@/components/LogOrder/MobileShop.vue'
import MobileOrderDialogEditOrder from '@/components/LogOrder/MobileOrderDialogEditOrder.vue'
import { sync } from 'vuex-pathify'
export default {
    name: 'MobileLogOrder',
    components: { MobileAllOrder, MobileShop, MobileOrderDialogEditOrder },
    computed: {
        type: sync('orderMobile/type'),
        currentTabComponent: function () {
            if (this.type === 0) {
                return 'Mobile-all-order'
            } else {
                return 'Mobile-shop'
            }
        },
        diableOrderStatusFalse () {
            console.log('this.editArray', this.editArray)
            if (!this.editArray) {
                return false
            } else {
                return true
            }
        }

    },
    data () {
        return {
            // type: 0, // default All Order
            searchOrderId: '',
            searchShopName: '',
            datePickTo: this.$dayjs(new Date()).format('YYYY-MM-DD'),
            // datePickTo: '2019-06-07',
            countSelect: 0,
            flagFetch: false,
            timeout: null,
            currentPage: 1,
            editArray: true,
            statusSave: [
                { id: true, name: 'บันทึก', nameEn: 'edit', count: 0 },
                { id: false, name: 'ไม่บันทึก', nameEn: 'noEdit', count: 0 }

            ],
            isAutoSave: [],
            countAutoSave: 0,
            statusSelect: [1, 2, 3],
            statusList: [
                { id: 1, name: 'รอดำเนินการ', nameEn: 'pending', count: 0 },
                { id: 2, name: 'เตรียมตัวส่ง', nameEn: 'prepareToShip', count: 0 },
                { id: 3, name: 'พร้อมจัดส่ง', nameEn: 'readyToShip', count: 0 }
            ],
            printStatusSelect: false,
            statusPrint: [
                { id: 1, name: 'ปริ้นแล้ว', nameEn: 'no_edit_print', count: 0, value: true },
                { id: 2, name: 'ยังไม่ปริ้น', nameEn: 'no_edit_no_print', count: 0, value: false }
            ],
            datePickToRange: [this.$dayjs(new Date()).subtract(7, 'day').format('YYYY-MM-DD'), this.$dayjs(new Date()).format('YYYY-MM-DD')],
            dialogShowEditOrderMobile: {
                isShow: false
            }
        }
    },
    mounted () {

    },
    methods: {
        onSelectStatus (val) {
            this.onSearch(true)
        },
        selectedType (val) {
            this.onSearch(true)
        },
        onSearch (flagFetch, clearSelected = true, autoSave = null) {
            clearTimeout(this.timeout)
            this.timeout = setTimeout(() => {
                if (this.type === 0) {
                    this.$refs.selectComponent.fetchOrder(this.searchOrderId, this.datePickToRange, this.statusSelect, flagFetch, this.editArray, clearSelected, this.printStatusSelect)
                } else if (this.type === 1) {
                    this.$refs.selectComponent.fetchShopSearch(this.searchShopName, this.datePickTo)
                }
            }, 500)
        },
        onSearchEmit (val) {
            this.onSearch(false, val)
        },
        createShipment () {
            this.$refs.selectComponent.createShipment()
        },
        setCountSelect (val) {
            this.countSelect = val
        },
        setStatusCount (val) {
            this.statusList[0].count = val.pending
            this.statusList[1].count = val.prepareToShip
            this.statusList[2].count = val.readyToShip

            this.statusSave[0].count = val.edit
            this.statusSave[1].count = val.noEdit

            this.statusPrint[0].count = val.noEditPrint
            this.statusPrint[1].count = val.noEditNoPrint
        },
        onShowCustomerEditOrderMobile () {
            this.dialogShowEditOrderMobile.isShow = !this.dialogShowEditOrderMobile.isShow
        },
        onChangeAutoSave (val) {
            this.onSearch(true)
        }
    }
}
</script>

<style lang="scss">
.disableCheckStatus{
    .el-checkbox-button.is-disabled .el-checkbox-button__inner {
        color: #FFFFFF !important;
        cursor: not-allowed !important;
        background-image: none !important;
        background-color: teal !important;
        border-color: teal !important;
        -webkit-box-shadow: -1px 0 0 0 #66b3b3 !important;
        box-shadow: -1px 0 0 0 #66b3b3 !important;
    }
}

</style>
